import {IEPActions} from './IEPActions';

//Содержимое ADMS каталога
const initialIEPState = {
  content: null,          //Содержимое пакета обмена
  images: [],             //Список полученных картинок
  wsdl: {},               //WSDL файл
  xsd: {},                //XSD файл
}

export const iep = (state = { ...initialIEPState} , action) => {
    switch (action.type) {
        case "IEPActions.LOAD_CONTENT_STARTED":
            return {
                ...state,
                load: true
            };
        case "IEPActions.LOAD_CONTENT_OK":
            return {
                ...state,
                content: action.content,
                images: action.images,
                xsd: action.xsd,
                wsdl: action.wsdl,
                load: true
            };
        case "IEPActions.LOAD_CONTENT_ERROR":
            return {
                ...state,
                content: null,
                load: false
            };
        default:
            return state;
    }
}
